import React, { useEffect, useState } from 'react'
import './App.css'
import 'react-confirm-alert/src/react-confirm-alert.css'

import Header from './components/layout/Header'

import Authorisation from './components/Authorisation'
import Chatbot from './components/chat/Chatbot'
import UserProfile from './components/profile/UserProfile'
import Pricing from './components/profile/PricingPage'
import DirectToStore from './components/profile/Directory'
import { ShareCardStage } from './components/shareable_feature/ShareCard'
import {
  DiagnosticsCard,
  SAMPLE_DIAGNOSTICS,
} from './components/shareable_feature/Cards'
import { SAMPLE_ROUTINE } from './components/shareable_feature/sampleData'

const APP_STATE = {
  AUTHORISATION: 'authorisation',
  CHATBOT: 'chatbot',
  PROFILE: 'profile',
  PRICING: 'pricing',
  DIRECT_TO_STORE: 'directtostore',
  DESIGN_PREVIEW: 'designpreview',
}

function DesignPreviewScreen({ goToProfile }) {
  return (
    <div
      style={{
        minHeight: '100%',
        padding: '24px 16px 40px',
        background: '#fdf8f9',
      }}
    >
      <div style={{ maxWidth: 980, margin: '0 auto' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 12,
            marginBottom: 16,
            flexWrap: 'wrap',
          }}
        >
          <div>
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: '0.12em',
                color: '#a8295d',
                textTransform: 'uppercase',
              }}
            >
              Temporary preview
            </div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#111' }}>
              Diagnostics card design workspace
            </div>
          </div>
          <button
            onClick={goToProfile}
            style={{
              border: '1px solid #e8cdd5',
              background: '#fff',
              color: '#a8295d',
              borderRadius: 999,
              padding: '8px 14px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Back to profile
          </button>
        </div>

        <div
          style={{
            background: '#fff',
            borderRadius: 20,
            border: '1px solid #f1dfe4',
            padding: 16,
            boxShadow: '0 12px 30px rgba(168,41,93,0.08)',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            style={{ transform: 'scale(0.92)', transformOrigin: 'top center' }}
          >
            <DiagnosticsCard data={SAMPLE_DIAGNOSTICS} />
          </div>
        </div>
      </div>
    </div>
  )
}

function App() {
  const [appState, setAppState] = useState(APP_STATE.AUTHORISATION)
  const [disableHeader, setDisableHeader] = useState(true)

  useEffect(() => {
    setDisableHeader(appState === APP_STATE.AUTHORISATION)
  }, [appState])

  const goToAuthorisation = () => setAppState(APP_STATE.AUTHORISATION)
  const goToChatbot = () => setAppState(APP_STATE.CHATBOT)
  const goToUserProfile = () => setAppState(APP_STATE.PROFILE)
  const goToPricing = () => setAppState(APP_STATE.PRICING)
  const goToDirectToStore = () => setAppState(APP_STATE.DIRECT_TO_STORE)
  const goToDesignPreview = () => setAppState(APP_STATE.DESIGN_PREVIEW)

  return (
    <div className='App'>
      <Header
        disableHeader={disableHeader}
        goToAuthorisation={goToAuthorisation}
        goToUserProfile={goToUserProfile}
        goToPricing={goToPricing}
        goToChatbot={goToChatbot}
        goToDirectToStore={goToDirectToStore}
        goToDesignPreview={goToDesignPreview}
      />

      <main className='app-main'>
        {appState === APP_STATE.AUTHORISATION && (
          <Authorisation goToChatbot={goToChatbot} />
        )}

        {appState === APP_STATE.CHATBOT && (
          <Chatbot
            goToPricing={goToPricing}
            goToUserProfile={goToUserProfile}
            goToAuthorisation={goToAuthorisation}
          />
        )}

        {appState === APP_STATE.PROFILE && (
          <ShareCardStage
            routineData={SAMPLE_ROUTINE}
            diagnosticsData={SAMPLE_DIAGNOSTICS}
          >
            <UserProfile
              goToAuthorisation={goToAuthorisation}
              goToPricing={goToPricing}
              goToChatbot={goToChatbot}
            />
          </ShareCardStage>
        )}

        {appState === APP_STATE.PRICING && (
          <Pricing
            goToAuthorisation={goToAuthorisation}
            goToChatbot={goToChatbot}
          />
        )}

        {appState === APP_STATE.DIRECT_TO_STORE && (
          <DirectToStore
            goToAuthorisation={goToAuthorisation}
            goToChatbot={goToChatbot}
          />
        )}

        {appState === APP_STATE.DESIGN_PREVIEW && (
          <DesignPreviewScreen goToProfile={goToUserProfile} />
        )}
      </main>
    </div>
  )
}

export default App
